// Readable log lines. Packages report a generic "<seat> performed <kind>." for every command; a theme
// map named `log` (action kind to phrase) rewrites it as "<Seat label> <phrase>.", and the phrase "-"
// drops that line where a more specific event says the same thing (a roll followed by "rolled 8").
// Seat IDs anywhere in a line read as seat labels. Presentation only: the host's log is unchanged.

import type { LogEntry } from '../session/Session';

const GENERIC = /^(\S+) performed (\w+)\.$/;
export const HIDDEN_PHRASE = '-';

export function logLine(message: string, seats: { id: string; label: string }[], phrases?: Record<string, string>): string | null {
  let text = message;
  const generic = GENERIC.exec(message);
  if (generic && phrases) {
    const phrase = phrases[generic[2]!];
    if (phrase === HIDDEN_PHRASE) return null;
    if (phrase) text = `${generic[1]} ${phrase}.`;
  }
  for (const s of [...seats].sort((a, b) => b.id.length - a.id.length)) {
    if (s.label && s.label !== s.id) text = text.replace(new RegExp(`\\b${s.id.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'g'), s.label);
  }
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function readableLog(log: LogEntry[], seats: { id: string; label: string }[], phrases?: Record<string, string>): LogEntry[] {
  return log.flatMap(e => { const message = logLine(e.message, seats, phrases); return message === null ? [] : [message === e.message ? e : { ...e, message }]; });
}
